import React, { useEffect, useState } from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
Chart.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const VelocidadLinealTotal = () => {
    const [labels, setLabels] = useState([]);
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
const API_URL = process.env.REACT_APP_API_URL || '';

    useEffect(() => {
        let intervalId;
        const fetchData = () => {
            setLoading(true);
            setError(null);
            fetch(`${API_URL}/velocidad-lineal-total`)
                .then(res => {
                    if (!res.ok) throw new Error('Error al obtener datos');
                    return res.json();
                })
                .then(result => {
                    const lecturas = result.lecturas || [];
                    setLabels(lecturas.map(l => {
                        const s = l.fechaLocal || '';
                        // "9/6/2026, 11:53:49 p.m." → "9/6 23:53"
                        const m = s.match(/^(\d+)\/(\d+)\/\d+,\s+(\d+):(\d+):\d+\s+(a\.\s*m\.|p\.\s*m\.)$/);
                        if (!m) return s;
                        let h = parseInt(m[3], 10);
                        const ampm = m[5].replace(/\s/g, '');
                        if (ampm === 'p.m.' && h !== 12) h += 12;
                        if (ampm === 'a.m.' && h === 12) h = 0;
                        return `${m[1]}/${m[2]} ${String(h).padStart(2, '0')}:${m[4]}`;
                    }));
                    setData(lecturas.map(l => l.velocidadLineal));
                    setTotal(result.total || 0);
                    setLoading(false);
                })
                .catch(err => {
                    setError(err.message);
                    setLoading(false);
                });
        };
        fetchData();
    intervalId = setInterval(fetchData, 300000); // refresca cada 5 minutos
        return () => clearInterval(intervalId);
    }, []);

    const chartData = {
        labels,
        datasets: [
            {
                label: 'Velocidad Lineal (m/min)',
                data,
                backgroundColor: '#59dab3ff',
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                labels: {
                    color: '#c9bfbfff',
                    font: { family: 'Roboto', size: 12, weight: '300' }
                }
            },
            title: {
                display: true,
                text: `Total: ${total.toFixed(2)} m/min`,
                color: '#a2aab4',
                font: { family: 'Roboto', size: 10 }
            }
        },
        scales: {
            x: { grid: { color: 'rgba(30,90,180,0.2)', lineWidth: 0.3 }, ticks: { color: '#8ab0cc' } },
            y: { grid: { color: 'rgba(30,90,180,0.2)', lineWidth: 0.3 }, ticks: { color: '#8ab0cc' } }
        }
    };

    if (loading) {
        return <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Cargando datos...</div>;
    }
    if (error) {
        return <div style={{ height: '100%', color: 'red', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Error: {error}</div>;
    }
    if (!data.length) {
        return <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>No hay datos de velocidad lineal.</div>;
    }
    return (
        <div style={{ height: '100%', width: '100%' }}>
            <Bar data={chartData} options={options} />
        </div>
    );
};

export default VelocidadLinealTotal;
